import React, {  } from "react";
import type * as controls from "../PhoenixFormsV4.Controls";
import RadioGroup from "@mui/material/RadioGroup";
import FormLabel from "@mui/material/FormLabel";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import PNXLabel from "./PNXLabel";
import { MSelect } from "components/Shared";


interface ReadOnlyProps {
  controlProps: controls.ListFormControl;
}
interface Props extends ReadOnlyProps {  
  updateValue: (newValue: string) => void;
  onControlBlur: () => void;
};

const PhoenixSelect1 = ({
  controlProps,
  updateValue,
  onControlBlur,
} : Props) => {

  const appearance = controlProps.appearance ?? "full";
  const id = `select1-${controlProps.id}`;

  const getSelectedOption = () => { // for the react-selct controls
    if (!controlProps.value) return null;

    let valueOption = null;

    const options = controlProps.items.filter(i => i.value === controlProps.value);
    if (options.length) {
      valueOption = options[0];
    }
    else if (appearance === "phoenix:combo") { // combo box can have a created option
      valueOption = { label: controlProps.value, value: controlProps.value };
    }

    return valueOption;
  };

  switch (appearance) {
    case "full":
      return <div>
        <FormLabel component="legend"><PNXLabel helpTopicId={controlProps.topicId}>{controlProps.label}</PNXLabel></FormLabel>
        <RadioGroup
          name={id}
          value={controlProps.value ?? ""}
          onChange={(e) => { updateValue(e.target.value); }}
          onBlur={() => onControlBlur()}
        >
          {controlProps.items.map((item, idx) => (
            <FormControlLabel key={idx} value={item.value} control={<Radio />} label={item.label} />
          ))}
        </RadioGroup>
      </div>
    case "compact":
      return (
        <div>
          <PNXLabel helpTopicId={controlProps.topicId}>{controlProps.label}</PNXLabel>
          <MSelect
            value={getSelectedOption()}
            onChange={option => updateValue(option?.value ?? "")}
            onBlur={() => onControlBlur()}
            options={controlProps.items}
            placeholder="Select..."
            isClearable
            menuPlacement="auto"
          />
        </div>
      );
    case "minimal": 
      return (
        <div>
          <PNXLabel helpTopicId={controlProps.topicId}>{controlProps.label}</PNXLabel>
          <MSelect
            defaultValue={getSelectedOption()}
            onChange={option => updateValue(option?.value ?? "")}
            onBlur={() => onControlBlur()}
            options={controlProps.items}
            placeholder="Search or Enter Value..."
            isClearable
            menuPlacement="auto"
          />
        </div>
      );
    case "phoenix:combo": 
      return (
        <div>
          <PNXLabel helpTopicId={controlProps.topicId}>{controlProps.label}</PNXLabel>
          <MSelect
            defaultValue={getSelectedOption()}
            onChange={option => updateValue(option?.value ?? "")}
            onBlur={() => onControlBlur()}
            options={controlProps.items}
            placeholder="Search or Enter Value..."
            isClearable
            creatable
            menuPlacement="auto"
          />
        </div>
      );
  }
};

export const willPhoenixSelect1ReadOnlyRender = (controlProps: controls.ListFormControl) => !!controlProps.value;

export const PhoenixSelect1ReadOnly = ({
  controlProps,
} : ReadOnlyProps) => {

  if (!controlProps.value) return null;

  // map value to item label if present
  const option = controlProps.items.filter(item => item.value === controlProps.value);
  const mappedValue = option.length ? option[0].label : controlProps.value;    

  return (
    <div>
      <PNXLabel>{controlProps.label}</PNXLabel>
      <div>{mappedValue}</div>
    </div>
  );
};


export default PhoenixSelect1;